export default {
  '百科内容':'百科內容',
  '百科视频':'百科視頻',
  '请上传视频':'請上傳視頻',
  '请上传PDF文件':'請上傳PDF文件',
  '预览':'預覽',
  '仅支持扩展名pdf：':'50M以內；支持擴展名：.pdf',
  '分类列表':'分類列表',  
  '新增分类':'新增分類',  
  '新增':'新增',
  '编辑分类':'編輯分類', 
  '确认要删除该分类吗？':'確認要刪除該分類嗎？',  
  '分类删除成功！':'分類刪除成功！',  
  '分类名称':'分類名稱',
  '分类名称已存在':'分類名稱已存在',  
  '一级分类名称':'一級分類名稱',
  '二级分类名称':'二級分類名稱',
  '编辑分类成功！':'編輯分類成功！',  
  '新增分类成功！':'新增分類成功！', 
  '资源内容':'資源內容',
  '百科标题':'百科標題',
  '视频列表':'視頻列表',
  '支持上传mp4格式':'支援上傳mp4格式，最大不超過1G。',
  '视频':'視頻',
  '标题':'標題',
  '简介':'簡介',
  '添加视频':'添加視頻',
  '编辑视频':'編輯視頻',
  '添加视频':'添加視頻',
  '视频标题':'視頻標題',
  '描述':'描述',
  '视频上传中，是否取消？':'上傳視頻中，是否取消？',
  '确认要删除该视频吗？':'確認要刪除該視頻嗎？',
  '视频删除成功！':'視頻刪除成功！',
  '序号':'序號',
  '请输入分类名称搜索':'請輸入分類名稱搜尋',
  '导入分类':'匯入分類',
  '分类导入完成':'分類匯入完成',
  '分类导入模板':'分類匯入範本',
}
